"use client";

import { useEffect } from "react";
import { CtaLink } from "@/components/ui/CtaLink";
import { Status } from "@/components/ui/Status";
import { models } from "@/content/facts";
import { modelosPage } from "@/content/modelos";
import { worldBus } from "@/lib/world-bus";
import styles from "./models.module.css";

// Los tres modelos (guía 8.3). Al pasar el cursor, enfocar o tocar uno, su árbol se
// enciende en la escena (guía 7.4): Nano encendido, 150M en líneas que se forman, 1B
// como silueta punteada.
export function ModelList() {
  useEffect(() => () => {
    worldBus.modelsFocus = -1;
  }, []);

  const focus = (i: number) => () => {
    worldBus.modelsFocus = i;
  };
  const blur = () => {
    worldBus.modelsFocus = -1;
  };

  const bodies = [modelosPage.nano.body, modelosPage.m150.body, modelosPage.b1.body];

  return (
    <ol className={styles.list}>
      {models.map((m, i) => (
        <li
          key={m.id}
          className={styles.model}
          data-kind={m.status.kind}
          onPointerEnter={focus(i)}
          onPointerLeave={blur}
          onFocus={focus(i)}
          onBlur={blur}
          onTouchStart={focus(i)}
        >
          <div className={styles.head}>
            <h2 className={styles.name}>{m.name}</h2>
            <Status kind={m.status.kind}>{m.status.label}</Status>
          </div>
          <p className={styles.body}>{bodies[i]}</p>
          {m.id === "nano" && (
            <>
              <ul className={styles.data}>
                {modelosPage.nano.data.map((d) => (
                  <li key={d}>{d}</li>
                ))}
              </ul>
              <div className={styles.actions}>
                <CtaLink href={modelosPage.nano.sheet.href}>{modelosPage.nano.sheet.label}</CtaLink>
                <CtaLink href={modelosPage.nano.download.href}>{modelosPage.nano.download.label}</CtaLink>
              </div>
            </>
          )}
        </li>
      ))}
    </ol>
  );
}
